export default function Register(props) {
	const { children } = props;
	return children;
}
